import { createSelector } from '@reduxjs/toolkit';
import { ClientConfiguration } from 'api/client-domain/client-domain.types';
import { incApi } from 'api/inc-api';
import { FeatureFlag, isFeatureFlagEnabled } from 'util/client-configuration';

export const selectClientConfigEndpoint =
  incApi.endpoints.getClientConfig.select(null);

export const selectClientConfig = createSelector(
  selectClientConfigEndpoint,
  clientConfigEndpoint => clientConfigEndpoint.data,
);

export const selectIncentivioPayments = createSelector(
  selectClientConfig,
  clientConfig => clientConfig?.incentivioPayments,
);

export const selectIncentivioEmailSetting = createSelector(
  selectClientConfig,
  clientConfig => clientConfig?.emailSetting,
);

export const selectIncentivioDynamicEmailTemplateEnabled = createSelector(
  selectIncentivioEmailSetting,
  incentivioEmailSetting => incentivioEmailSetting?.dynamicEmailTemplateEnabled,
);

export const selectIncentivioPaymentFee = createSelector(
  selectIncentivioPayments,
  incentivioPayments => incentivioPayments?.paymentFee,
);

export const selectIncentivioPaymentProcessingRate = createSelector(
  selectIncentivioPayments,
  incentivioPayments => incentivioPayments?.processingRate,
);

export const selectAllFeatureFlags = createSelector(
  selectClientConfig,
  clientConfig =>
    Object.keys(FeatureFlag)
      .filter(featureFlag => !isNaN(Number(featureFlag)))
      .reduce(
        (result, featureFlag) => ({
          ...result,
          [featureFlag]: isFeatureFlagEnabled(
            featureFlag as unknown as FeatureFlag,
            clientConfig,
          ),
        }),
        {},
      ),
);

export const selectSMS = createSelector(
  selectClientConfig,
  clientConfig => clientConfig?.sms,
);

export const selectIsSMSMarketingEnabled = createSelector(
  selectSMS,
  sms => sms?.enabledMarketing,
);

export const selectIsHideDownloadCustomerListOption = createSelector(
  selectClientConfig,
  (clientConfig: ClientConfiguration) =>
    !!clientConfig?.downloadCustomerListEnabled,
);

export const selectEnableFulfillText = createSelector(
  selectClientConfig,
  (clientConfig: ClientConfiguration) => !!clientConfig?.enableFulFillText,
);
